import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeature from './Component/SummaryFeature';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import { PriceUtility } from '../../utilities/PriceUtility';
import IsNullOrUndefined from '../../utils/ObjectUtils';

const SummarySectionsList = () => {
  const {
    categories, sections, totalPrice, user, isPublic, vat,
  } = useSelector(state => state.configurator);

  return (
    <div className="summary-sections-list">
      <div className="summary-sections-list-header">
        <div className="title">{TranslationUtility.GetFormattedMessageForUI('ui-summary-panel-title',
            'Su configuración')}
        </div>
      </div>
      <div className="description">
        {TranslationUtility.GetFormattedMessageForUI('ui-summary-panel-subtitle',
            'A continuación se muestra un resumen de las opciones que ha seleccionado:')}

      </div>
      {/* eslint-disable-next-line max-len */}
      <div className={`container-sections logged-in ${vat.vat_enabled ? 'vat-enabled' : ''}${vat.vat_breakdown_disabled ? ' vat_breakdown_disabled' : ''}${(vat.public_prices_enabled === false || vat.public_prices_total_price_enabled === false) ? ' public' : ''}`}>
        {sections !== undefined && sections.map((section, index) => (
          <>
            <SummarySectionTitle section={section} includesPrices={false} />
            <div className="summary-feature-container">
              {
                  section.categories.map((category, index2) => {
                      if (category.features !== undefined && category.features.length > 0) {
                          return (
                            <SummaryFeature
                              categoryName={TranslationUtility.GetFormattedMessageForCategoryName(category)}
                              feature={category.features.find(feature => feature.id === category.selected_feature)}
                              disabled={category.disabled}
                            />
                          );
                      }
                      return null;
                  })
              }
            </div>
          </>
              ))}
      </div>
      {/* eslint-disable-next-line max-len */}
      {vat.public_prices_enabled !== false && vat.public_prices_total_price_enabled !== false && (
        // eslint-disable-next-line max-len
      <div className={`total-price-summary-container${vat.vat_enabled ? ' vat-enabled' : ''}${vat.vat_breakdown_disabled ? ' vat_breakdown_disabled' : ''}`}>
        <div className="divider" />
        {!IsNullOrUndefined(vat) && !vat.vat_breakdown_disabled
              ? (
                <div className="total-price-exc-vat-row">
                  <div className="title">
                    {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-excl-vat',
                        'TOTAL OPCIONES (sin IVA)')}
                  </div>
                  <div className="value">{currencyFormatter.format(totalPrice)}</div>
                </div>
        ) : null}
        {!IsNullOrUndefined(vat) && vat.vat_enabled && !vat.vat_breakdown_disabled
                ? (
                  <div className="vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-vat',
                                'IVA')}
                    </div>
                    <div className="value">
                      {currencyFormatter.format(PriceUtility.calculateVatValue(categories, vat))}
                    </div>
                  </div>
                ) : null}
        {!IsNullOrUndefined(vat) && vat.vat_enabled
                ? (
                  <div className="total-price-inc-vat-row">
                    <div className="title">
                      {TranslationUtility.GetFormattedMessageForUI('ui-summary-total-price-incl-vat',
                                'PRECIO TOTAL OPCIONES (con IVA)')}
                    </div>
                    <div className="value">
                      {currencyFormatter.format(PriceUtility.calculateTotalPriceIncVat(categories, vat))}
                    </div>
                  </div>
                ) : null}
      </div>
      )}
    </div>
  );
};

export default SummarySectionsList;
